module.exports = __webpack_public_path__ + "static/uni_weinberg-6f820fcbb85a82e50888f9979f2b89a8.png";